import videojs from 'video.js';
/* eslint-disable global-require */

// utils
const urlToEl = (url) => {
  const DOMImg = document.createElement('img');
  DOMImg.src = url;
  return DOMImg;
};

// make sure that age icon is shown in first position
const transformArrayToHaveAgeIconAsFirstItem = (icons) => {
  const indexOfAgeIcon = icons.findIndex((icon) => icon.type.startsWith('age'));
  const ageIconObject = icons[indexOfAgeIcon];
  const iconsArrayWithAgeIconAsFirstItem = [ageIconObject].concat(icons);
  const iconsArrayWithoutDuplicates = iconsArrayWithAgeIconAsFirstItem.filter(
    (_, i) => i !== indexOfAgeIcon + 1
  );

  return iconsArrayWithoutDuplicates;
};

const getIcon = (type) => {
  switch (type) {
    case 'age-6-and-up':
      return require('../assets/icons/icon_kijkwijzer_6.svg');
    case 'age-9-and-up':
      return require('../assets/icons/icon_kijkwijzer_9.svg');
    case 'age-12-and-up':
      return require('../assets/icons/icon_kijkwijzer_12.svg');
    case 'age-16-and-up':
      return require('../assets/icons/icon_kijkwijzer_16.svg');
    case 'age-all':
      return require('../assets/icons/icon_kijkwijzer_al.svg');
    case 'foul-language':
      return require('../assets/icons/icon_kijkwijzer_taal.svg');
    case 'fear':
      return require('../assets/icons/icon_kijkwijzer_angst.svg');
    case 'violence':
      return require('../assets/icons/icon_kijkwijzer_geweld.svg');
    case 'sex':
      return require('../assets/icons/icon_kijkwijzer_seks.svg');
    case 'drugs':
      return require('../assets/icons/icon_kijkwijzer_drugs.svg');
    case 'discrimination':
      return require('../assets/icons/icon_kijkwijzer_discriminatie.svg');
    default:
      return '';
  }
};

const appendChild = (parentEl) => (DOMElement) =>
  parentEl.appendChild(DOMElement);

const kijkwijzerUrlReducer = (allPrev, { type, imageUrl }) => {
  if (allPrev.includes(imageUrl)) {
    return allPrev;
  }

  const url = getIcon(type);

  return [...allPrev, url];
};

// plugin
function kijkwijzerPlugin(options) {
  const player = this;
  const kwDiv = document.createElement('div');
  kwDiv.classList.add('kijkwijzer');

  const imagesStartingWithAge = transformArrayToHaveAgeIconAsFirstItem(
    options.images
  );
  const imageUrls = imagesStartingWithAge.reduce(kijkwijzerUrlReducer, []);
  const imageElements = imageUrls.map(urlToEl);
  const appendChildTokwDiv = appendChild(kwDiv);

  imageElements.forEach(appendChildTokwDiv);

  const videoElement = player.el();
  videoElement.appendChild(kwDiv);
}

videojs.registerPlugin('kijkwijzerPlugin', kijkwijzerPlugin);

export default {
  mapPropStateToOptions: ({ classifications }) => ({
    images: classifications || [],
  }),
};
